/**
 * Package Name: custom.js
 * Subpackage: jshm
 * Author: Raven Developers
 * Author URI: https://www.ravendevelopers.com
 * Description: Javascript
 * Author: anithegregorian
 * Created: 12/06/23
 * Version: 1.0
 * License: Creative Commons 3.0 Attribution
 * License URI: https://creativecommons.org/licenses/by/3.0/us/
 * Tags: app
 **/

document.addEventListener('DOMContentLoaded', function () {
    const programs = [].slice.call(document.querySelectorAll('ul.program-rows'));

    programs.map((program) => {
        if (program.previousElementSibling && program.previousElementSibling.tagName === 'P') {
            program.previousElementSibling.classList.add('program-row-title');
        }
    });

});
